//workouts
export const workoutsLevels = [
  'Female Beginner',
  'Female Intermediate',
  'Female Advanced',
  'Male Beginner',
  'Male Intermediate',
  'Male Advanced'
];

export const workoutsPhases = [...Array(100).keys()].map(value => {
  return { value: value + 1, option: `Phase ${value + 1}` };
});

// exercises
// exercise types
export const exerciseTypes = [
  'Strength', 'Met Con', 'Stretching', 'Powerlifting', 'Cardio'
];

// exercise muscle
export const exerciseMuscles =  [
  "Abdominals",
  "Anterior Deltoid",
  "Biceps","Calves",
  "Chest", "Forearms",
  "Gluteal Muscles",
  "Hamstrings",
  "Latissimus Dorsi",
  "Lower Back",
  "Lower Pectoralis Major",
  "Medial Deltoid",
  "Middle Back",
  "Pectoralis Major",
  "Posterior Deltoid",
  "Quadriceps",
  "Shoulders",
  "Trapezius",
  "Triceps",
  "Upper Pectoralis Major",
  "Other"
]

// Exercise Mechanics Type
export const exerciseMechanicsType = [
  "Compound", "Dynamic", "Isolation", "N/A", "Other"
];

// Exercise Mechanics Type
export const exerciseLevels = [
  "Beginner", "Intermediate", "Advanced", "Expert"
];

// Exercise Mechanics Type
export const exerciseForces = [
  "Hinge", "Pull", "Push", "Static", "Other", "N/A"
];